import React from 'react'
import { Column, Columns } from '../../bulma'
import SubscriptionInfoModal from './SubscriptionInfoModal'
import { BookshelfPlusLogo } from '../../core/icons'

function BookshelfInfoModal(props) {
  const { checkoutStep, ...rest } = props

  const content = () => (
    <div className="content">
      <Columns>
        <Column>
          <strong>Unlimited Audiobooks:</strong>
          <br />
            Listen to as much audio you want from our audio library including new releases the day they come out.
        </Column>
        <Column>
          <strong>Over 2,000 eBooks:</strong>
          <br />
            Read bestselling eBooks from favorite authors like Gerald N. Lund, Elder Maxwell, and more!
        </Column>
      </Columns>
    </div>
  )

  return (
    <SubscriptionInfoModal
      title={<BookshelfPlusLogo className="modal-logo has-fill-plus" />}
      modal="bookshelf"
      content={content()}
      checkoutStep={checkoutStep}
    />
  )
}

export default BookshelfInfoModal
